// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2b2c886a","453":"029a8044","810":"c827c347"}[chunkId] + ".chunk.js";
};